// extracted by mini-css-extract-plugin
module.exports = {"label-button":"UploadFileInput_label-button__2Fmam","file-input":"UploadFileInput_file-input__2dVlQ"};